import { LayoutConfig } from '@spartacus/storefront';

export const SloanLoginLayoutConfig: LayoutConfig = {
  layoutSlots: {
    KnBrLoginPageTemplate: {
      slots: ['LeftContentSlot', 'SiteTitle'],
    },
  },
};
